import { ScrollArea } from 'components/ScrollArea/ScrollArea';
import { Stack } from 'components/Stack/Stack';
import { BodySmall } from 'components/Text/BodySmall';
import type { CmsApiMiniPage } from 'modules/cms/api/types/CmsApiMiniPage';
import type { CmsApiMiniSubsite } from 'modules/cms/api/types/CmsApiMiniSubsite';
import type { CmsApiSubsite } from 'modules/cms/api/types/CmsApiSubsite';
import { spacing } from 'theme/theme';

import { SubsiteLink } from './SubsiteLink';

type Props = {
  subsites: CmsApiMiniSubsite[];
  parentSubsite: CmsApiSubsite;
};

export function PostSearchIncludedSubsites({ subsites, parentSubsite }: Props) {
  return (
    <div data-qa-id="side-filter-facet-subsites">
      <BodySmall>{getText('Category')}</BodySmall>
      <ScrollArea
        direction="horizontal"
        data-qa-id="search-filter-section-filters"
        hideScrollBar
        width="100%"
      >
        <Stack direction={{ xs: 'row', md: 'column' }} spacing={spacing[4]}>
          {subsites.map((subsite) => {
            // search is only available when there's a home page
            const homePage = subsite.homePage as CmsApiMiniPage;
            return (
              <SubsiteLink
                key={subsite.id}
                parentSubsite={parentSubsite}
                icon={subsite.icon}
                label={subsite.publicName}
                url={homePage.url}
              />
            );
          })}
        </Stack>
      </ScrollArea>
    </div>
  );
}
